export enum ReportTypeFilterEnum{
    ALL = "ALL",
    MAILBOX = "MAILBOX",
    CATEGORY = "CATEGORY",
    AGENT = "AGENT"
}